<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <mask id="mask0_24813_3900" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="1" y="1" width="18" height="18">
      <path d="M19 1H1V19H19V1Z" fill="white" />
    </mask>
    <g mask="url(#mask0_24813_3900)">
      <path d="M2.7998 9.48531L9.58802 2.69709C10.5253 1.75983 12.0449 1.75983 12.9821 2.69709C13.9194 3.63434 13.9194 5.15394 12.9821 6.0912L7.85561 11.2177" 
      stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
      <path d="M7.92651 11.147L12.9823 6.09122C13.9196 5.15396 15.4392 5.15396 16.3765 6.09122L16.4118 6.12657C17.3491 7.06383 17.3491 8.58343 16.4118 9.52068L10.2725 15.6601C9.96005 15.9725 9.96005 16.4789 10.2725 16.7913L11.5331 18.0521" 
      stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
      <path d="M11.2852 4.3941L6.26471 9.41456C5.32745 10.3518 5.32745 11.8714 6.26471 12.8087C7.20197 13.7459 8.72156 13.7459 9.65882 12.8087L14.6793 7.78821" 
      stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'MCPIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>